if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.submitButton = this.form.querySelector('[type="submit"]');
      this.errorMessageWrapper = this.querySelector('[data-product-form-error]');
      this.errorMessage = this.querySelector('[data-product-form-error-message]');
      this.defaultErrorMessage = this.dataset.errorMessage || '';
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    setErrorMessage(errorMessage = '') {
      if (!this.errorMessageWrapper || !this.errorMessage) return;

      const hasError = Boolean(errorMessage);
      this.errorMessageWrapper.toggleAttribute('hidden', !hasError);
      this.errorMessage.textContent = hasError ? errorMessage : '';
    }

    onSubmitHandler(event) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      event.preventDefault();

      if (this.submitButton?.disabled) return;
      this.setErrorMessage();

      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.setAttribute('aria-disabled', 'true');
      }

      const formData = new FormData(this.form);
      formData.append('sections', cartDrawer.getSectionIdsToRender().join(','));
      formData.append('sections_url', window.location.pathname);

      fetch(
        `${window.PureTheme?.root() || '/'}cart/add.js`,
        window.PureTheme?.createFetchConfig({
          method: 'POST',
          body: formData,
        }) || {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.setErrorMessage(
              window.PureTheme?.getErrorMessage(
                response.errors || response.description || response.message,
                this.defaultErrorMessage
              ) || this.defaultErrorMessage
            );
            return;
          }

          this.setErrorMessage();
          cartDrawer.renderContents(response);
          cartDrawer.open(this.submitButton || this.form);
        })
        .catch((error) => {
          console.error(error);
          this.setErrorMessage(this.defaultErrorMessage);
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.disabled = false;
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.removeAttribute('aria-disabled');
          }
        });
    }
  }

  customElements.define('product-form', ProductForm);
}
